"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.worldchain = void 0;
const defineChain_js_1 = require("../../utils/chain/defineChain.js");
exports.worldchain = (0, defineChain_js_1.defineChain)({
    id: 480,
    name: 'World Chain',
    network: 'worldchain',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://worldchain-mainnet.g.alchemy.com/public'] },
    },
    blockExplorers: {
        default: {
            name: 'World Chain Explorer',
            url: 'https://worldchain-mainnet.explorer.alchemy.com',
        },
    },
    testnet: false,
});
//# sourceMappingURL=worldchain.js.map